import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { MainDataModels } from 'src/app/models/maindata-models';
import { DatumFormatPipe } from 'src/app/pipes/datum-format.pipe';
import { MainDataService } from 'src/app/services/main-data.service';
import { MessageBoxService } from 'src/app/services/message-box.service';
import { SwissSettingsService } from 'src/app/services/swiss-settings.service';
import { AufgabeEintragComponent } from '../../pendenzen/aufgabe-eintrag/aufgabe-eintrag.component';

export interface AufgabenEintrag {
  id: string;
  beginntAm?: Date;
  faelligAm?: Date;
  title: string;
  beschreibung: string;
}

@Component({
  selector: 'app-aufgabe-liste',
  templateUrl: './aufgabe-liste.component.html',
  styleUrls: ['./aufgabe-liste.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AufgabeListeComponent implements OnInit {
  private dbAufgaben?: MainDataModels.Aufgabe[];
  public taskList: AufgabenEintrag[] = [];
  private currAufgabeMitBenutzern?: MainDataModels.AufgabeMitBenutzer;

  constructor(
    private svcMainData: MainDataService,
    private _datumFormatPipe: DatumFormatPipe,
    private svcMessageBox: MessageBoxService,
    public dialog: MatDialog,
    private swissSettings: SwissSettingsService,
    private router: Router,
    private route: ActivatedRoute,
    @Inject(MAT_SNACK_BAR_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.loadAufgaben();
  }

  loadAufgaben() {
    // Unerledigte Aufgaben Live vom Webservice holen
    this.svcMainData.getOpenUserTasks().subscribe({
      next: (res) => {
        this.dbAufgaben = res;
        this.loadListenAufgaben();
      },
      error: (err) => {
        // Webservice nicht verfügbar --> aus IndexedDB laden
        //this.loadTermineFromIndexedDB();
      },
    });
  }

  loadListenAufgaben() {
    if (this.dbAufgaben) {
      this.taskList = [];

      this.dbAufgaben.forEach((t) => {
        this.taskList.push({
          id: t.taskUID,
          beginntAm: t.startdate,
          faelligAm: t.dueDate,
          title: t.description,
          beschreibung: t.notes,
        });
      });
    }
  }

  formatDate(datum?: Date): string {
    if (datum) {
      // Formatiert das Datum in das Format "dd.MM.yyy HH.mm.ss"
      return this._datumFormatPipe.transformOnlyDate(datum);
    } else {
      return '';
    }
  }

  closeSnackbar() {
    this.data.preClose();
  }

  showAufgabenList() {
    this.data.preClose();
    this.router.navigate(['/meineaufgaben']);
  }

  showAufgabeDetail(auftrag: AufgabenEintrag) {
    this.svcMainData.loadTaskByID(auftrag.id).subscribe({
      next: (res) => {
        var dialogRef = this.dialog.open(AufgabeEintragComponent, {
          disableClose: true,
          width: '800px',
          data: res,
        });

        return dialogRef.afterClosed().subscribe({
          next: (result) => {
            if (result) {
              this.currAufgabeMitBenutzern = result;
              // Update Informations
              if (this.currAufgabeMitBenutzern) {
                this.svcMainData
                  .saveAufgabe(this.currAufgabeMitBenutzern)
                  .subscribe({
                    next: (res) => {
                      this.loadAufgaben();
                      this.svcMessageBox.showSuccess(
                        'Die Aufgabe wurde erfolgreich gespeichert.',
                        'Erfolgreich'
                      );
                    },
                    error: (error) => {
                      console.log(error);
                      this.svcMessageBox.showError(
                        'Die Aufgabe konnte nicht gespeichert werden!!',
                        '!! FEHLER !!'
                      );
                    },
                  });
              }
              if (this.swissSettings.getWebConfig().debugMode)
                console.log(
                  'Dialog Resultat (currAufgabeMitBenutzern): ',
                  this.currAufgabeMitBenutzern
                );
            }
          },
        });
      },
    });
  }
}
